"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { LibraryBig, Crown, Users, FolderOpen } from "lucide-react";
import { cn } from "@/lib/cn";

const TABS = [
  { label: "Tài liệu độc quyền", href: "/tai-lieu/doc-quyen", icon: Crown, exact: false },
  { label: "Tài liệu của tôi", href: "/tai-lieu/cua-toi", icon: FolderOpen, exact: false },
  { label: "Kho tài liệu mở", href: "/tai-lieu", icon: LibraryBig, exact: true },
  { label: "Chia sẻ từ cộng đồng", href: "/tai-lieu/cong-dong", icon: Users, exact: false },
] as const;

/** Menu con phân loại kho tài liệu — hiển thị ở đầu các trang tài liệu. */
export function DocumentTabs() {
  const pathname = usePathname();
  return (
    <nav aria-label="Phân loại tài liệu" className="-mb-px flex flex-wrap gap-1 border-b border-border">
      {TABS.map((t) => {
        const active = t.exact ? pathname === t.href : pathname.startsWith(t.href);
        const Icon = t.icon;
        return (
          <Link
            key={t.href}
            href={t.href}
            className={cn(
              "inline-flex items-center gap-1.5 border-b-2 px-3 py-2.5 text-body-sm font-medium transition-colors",
              active
                ? "border-primary text-primary"
                : "border-transparent text-muted hover:border-border-strong hover:text-foreground"
            )}
            aria-current={active ? "page" : undefined}
          >
            <Icon className="size-4" aria-hidden="true" />
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
